import { render, staticRenderFns } from "./shippingInformation.vue?vue&type=template&id=b02df1fc&scoped=true"
import script from "./shippingInformation.vue?vue&type=script&lang=js"
export * from "./shippingInformation.vue?vue&type=script&lang=js"
import style0 from "./shippingInformation.vue?vue&type=style&index=0&id=b02df1fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02df1fc",
  null
  
)

export default component.exports